import React from "react";
import { Bugfix, Feature, Media } from "./components";

export default (
  <div key={6}>
    <h2 className="text-caption font-black uppercase text-lg">Update 6</h2>
    <ul className="space-y-2">
      <Media>You can now send images in the comments.</Media>
      <Feature>You can now create, assign and change tasks in groups.</Feature>
      <Bugfix>Many small UX improvements and bugfixes.</Bugfix>
    </ul>
  </div>
);
